import React from 'react';
import { useSelector } from 'react-redux';

import { getCurrency } from 'user/userSelectors';
import { currencyFormatter, getMessage } from 'util/locale';
import { formatNumberRoundToNearest } from 'util/formatters/numberFormatter';

const PotentialGainLossRow = ({
  orginalAvgEstGrossRevenue,
  activeAvgEstGrossRevenue,
  yourPlanAvgEstGrossRevenue
}: {
  orginalAvgEstGrossRevenue: number;
  activeAvgEstGrossRevenue: number;
  yourPlanAvgEstGrossRevenue: number;
}) => {
  const currency = useSelector(getCurrency);
  const originalGainLoss
    = formatNumberRoundToNearest(orginalAvgEstGrossRevenue, 1)
    - formatNumberRoundToNearest(yourPlanAvgEstGrossRevenue, 1);
  const activeGainLoss
    = formatNumberRoundToNearest(activeAvgEstGrossRevenue, 1)
    - formatNumberRoundToNearest(yourPlanAvgEstGrossRevenue, 1);
  
  const isActiveGain = activeGainLoss >= 0;
  const originalSign = originalGainLoss >= 0 ? '+' : '-';
  const activeSign = isActiveGain ? '+' : '-';
  const activeClassName = isActiveGain ? 'isGain' : '';

  return (
    <tfoot>
      <tr>
        <th role='rowheader'>{getMessage('potential-gain-loss')}</th>
        <td></td>
        <td>
          {`${originalSign} ${currencyFormatter(Math.abs(originalGainLoss), currency, { round: true })}`}
        </td>
        <td className={activeClassName}>
          {`${activeSign} ${currencyFormatter(Math.abs(activeGainLoss), currency, { round: true })}`}
        </td>
      </tr>
    </tfoot>
  );
};

export default PotentialGainLossRow;
